export class TotalUserQuota {
    public totalQuota: number;
    public maxUsedQuota: number;

    constructor(json: any) {
        this.totalQuota = json.totalQuota;
        this.maxUsedQuota = json.maxQuota;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/TotalUserQuota.ts